import { ref } from 'vue';

// Client-side "recently opened" VOD folders (most recent first).
// Persisted in localStorage and shared (module-level reactive ref) so every
// component that calls useRecentFolders() observes the same state.
const STORAGE_KEY = 'castr.vod.recentFolders';
const MAX_RECENT = 8;

function load() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list.slice(0, MAX_RECENT) : [];
  } catch (e) {
    return [];
  }
}

const recentIds = ref(load());

function persist() {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(recentIds.value));
  } catch (e) { /* ignore quota / privacy mode */ }
}

export function useRecentFolders() {
  const recordVisit = (id) => {
    if (!id) return;
    recentIds.value = [id, ...recentIds.value.filter((x) => x !== id)].slice(0, MAX_RECENT);
    persist();
  };

  const removeRecent = (id) => {
    if (!id) return;
    recentIds.value = recentIds.value.filter((x) => x !== id);
    persist();
  };

  const clearRecent = () => {
    recentIds.value = [];
    persist();
  };

  return { recentIds, recordVisit, removeRecent, clearRecent };
}
